/* eslint-disable import/prefer-default-export */
import queryString from 'query-string';

import { ACH_CONTRACTS_KPI_PERFORMANCE_URL, ACH_CONTRACTS_PACING_URL } from '../../constants/ach/apiUrls';
import { achGetJSON } from './client';

// ADOPS-2705: per-contract daily KPI performance for the current grid page's ids.
export const getKpiPerformance = (achApiHost: string, ids: number[]): Promise<any> =>
  achGetJSON(
    achApiHost,
    `${ACH_CONTRACTS_KPI_PERFORMANCE_URL}?${queryString.stringify({ ids }, { arrayFormat: 'comma' })}`
  );

// ACH-bj8d: the BigQuery spend payload (total_impressions,
// budget_spent_monthly_summary, spend_goal_to_date, line_items_header) that
// ?spend=deferred drops from the contracts index, keyed by contract id string.
export const getPacing = (achApiHost: string, ids: number[]): Promise<any> =>
  achGetJSON(achApiHost, `${ACH_CONTRACTS_PACING_URL}?${queryString.stringify({ ids }, { arrayFormat: 'comma' })}`);
